module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"allies":{"tittle":"Nuestras Alianzas"}},"en":{"allies":{"tittle":"Our alliances"}},"pt":{"allies":{"tittle":"Nossas alianças"}}}')
  delete Component.options._Ctor
}
